import { useEffect, useState, useMemo, useRef } from 'react';
import * as stylex from '@stylexjs/stylex';
import { styles } from '../styles';
import { KnobPercentage } from './knob/KnobPercentage';
import { camelToStartCase } from '../helpers/camelToStartCase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Reverb = _ref => {
  let {
    audioContext,
    sourceNode,
    destinationNode,
    onNodeChange,
    postFxIndex
  } = _ref;
  const [reverb, setReverb] = useState();
  const [active, setActive] = useState(false);
  const reverbDestroyParamRef = useRef();
  useEffect(() => {
    const createReverb = async () => {
      if (audioContext && sourceNode && destinationNode && !reverb) {
        await audioContext.audioWorklet.addModule('dattorroReverb.js');
        const reverb = new AudioWorkletNode(audioContext, 'DattorroReverb', {
          outputChannelCount: [2]
        });
        reverbDestroyParamRef.current = reverb.parameters.get('destroy');
        setReverb(reverb);
      }
    };
    createReverb();
  }, [audioContext, destinationNode, sourceNode, reverb, onNodeChange]);
  useEffect(() => {
    const cleanup = () => {
      try {
        sourceNode.disconnect(reverb);
        reverb.disconnect(destinationNode);
        sourceNode.connect(destinationNode); // the reverb components internally stores audio node but tells the parent component if it's used or not
        onNodeChange(nodes => {
          const newNodes = [...nodes];
          newNodes[postFxIndex] = null;
          return newNodes;
        });
      } catch (err) {}
    };
    if (audioContext && sourceNode && destinationNode && active && reverb) {
      try {
        sourceNode.disconnect(destinationNode);
      } catch (err) {}
      sourceNode.connect(reverb);
      reverb.connect(destinationNode);
      onNodeChange(nodes => {
        const newNodes = [...nodes];
        newNodes[postFxIndex] = reverb;
        return newNodes;
      });
      return cleanup;
    }
  }, [audioContext, destinationNode, sourceNode, reverb, active, onNodeChange, postFxIndex]);
  useEffect(() => {
    return () => {
      if (reverbDestroyParamRef.current) {
        reverbDestroyParamRef.current.value = 1;
        onNodeChange(null);
      }
    };
  }, [onNodeChange]);
  const knobs = useMemo(() => {
    if (!reverb) {
      return null;
    }
    const paramsArr = Array.from(reverb.parameters.entries()).filter(_ref2 => {
      let [title] = _ref2;
      return title !== 'destroy';
    }).sort((_ref3, _ref4) => {
      let [title1] = _ref3;
      let [title2] = _ref4;
      return title1 === title2 ? 0 : title1 > title2 ? 1 : -1;
    });
    return paramsArr.map(_ref5 => {
      let [title, {
        minValue,
        maxValue,
        defaultValue
      }] = _ref5;
      return /*#__PURE__*/_jsx(KnobPercentage, {
        label: camelToStartCase(title),
        valueMin: minValue,
        valueMax: maxValue,
        valueDefault: defaultValue,
        onChange: val => {
          paramsArr.find(_ref6 => {
            let [t] = _ref6;
            return t === title;
          })[1].value = val;
        }
      }, title);
    });
  }, [reverb]);
  if (!reverb) {
    return /*#__PURE__*/_jsx("p", {
      children: "Please select profile first"
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("h4", {
      children: [/*#__PURE__*/_jsx("label", {
        htmlFor: "reverb",
        children: "Dattorro Reverb"
      }), "\xA0", /*#__PURE__*/_jsx("input", {
        type: "checkbox",
        id: "reverb",
        onClick: () => setActive(active => !active)
      })]
    }), /*#__PURE__*/_jsx("div", {
      ...stylex.props(styles.postFxControls),
      children: knobs
    })]
  });
};